import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CareerPlanSkill, CareerPlanSkillDetail } from 'src/app/models/career-plans';
import { CareerPlansService } from 'src/app/services/career-plans.service';
import { accordionAnimation } from 'src/app/animations/accordion';

@Component({
  selector: 'app-skills-row',
  templateUrl: './skills-row.component.html',
  styleUrls: ['./skills-row.component.scss'],
  animations: [accordionAnimation],
})
export class SkillsRowComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  skills: CareerPlanSkill[];

  skillDetail: CareerPlanSkillDetail;

  subscriptions: Subscription[] = [];
  accordionAnimation: string;

  constructor(private careerPlansService: CareerPlansService) {}

  ngOnChanges() {
    this.accordionAnimation = 'visible';
  }

  ngOnInit() {
    this.subscriptions.push(
      this.careerPlansService.getSkillUnrolledObs().subscribe((unrolledSkill) => {
        const unrolledSkillBellongsToThisRow =
          this.skills.find((skill) => skill.skillId === unrolledSkill.skillId) != null;
        if (!unrolledSkillBellongsToThisRow) {
          this.skillDetail = null;
        }
      })
    );
  }

  renderDetails(skillDetail: CareerPlanSkillDetail) {
    this.skillDetail = skillDetail;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
